import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';
import * as fromAuth from '../reducers/auth.reducer';
const ɵ0 = (state) => state.status;
export const selectAuthStatusState = createSelector(fromFeature.selectAuthState, ɵ0);
export const getLoggedIn = createSelector(selectAuthStatusState, fromAuth.getLoggedIn);
export { ɵ0 };
